import axiosClient from 'utils/axios';
import ENDPOINT from 'constants/endPoint';

export default {
  async getMe() {
    const path = ENDPOINT.PROFILE;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getProfileIntranet() {
    const path = ENDPOINT.PROFILE_INTRANET;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getProfileExtranet() {
    const path = ENDPOINT.PROFILE_EXTRANET;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async updateMe(payload) {
    const { userData } = payload;

    const path = ENDPOINT.PROFILE;

    const response = await axiosClient.put(`${path}`, userData);

    return response.data;
  },

  async uploadMyAvatar(payload) {
    const { avatar } = payload;

    const path = `${ENDPOINT.PROFILE}/avatar`;

    const response = await axiosClient.put(`${path}`, { avatar });

    return response.data;
  },

  async deleteMyAvatar() {
    const path = `${ENDPOINT.PROFILE}/avatar`;

    const response = await axiosClient.delete(`${path}`);

    return response.data;
  },

  async updateMyPassword(payload) {
    const { userPwd } = payload;

    const path = `${ENDPOINT.PROFILE}/password`;

    const response = await axiosClient.put(`${path}`, userPwd);

    return response.data;
  },
};
